module.exports = __webpack_public_path__ + "static/media/stream.4fa90987.jpg";